(() => {
  const overlaySelector = ".concierge-chatbot-overlay";
  const toggleSelector = '#concierge-chatbot [data-helium-name="floating-chat"]';
  let chatWasOpen = false;
  let syncScheduled = false;

  const getOpenOverlay = () => {
    const overlay = document.querySelector(overlaySelector);
    if (!overlay || overlay.hidden || overlay.getAttribute("aria-hidden") === "true") {
      return null;
    }

    return getComputedStyle(overlay).display === "none" ? null : overlay;
  };

  const syncChatScrollLock = () => {
    syncScheduled = false;
    chatWasOpen = Boolean(getOpenOverlay());
    document.documentElement.classList.toggle("qazmi-chat-open", chatWasOpen);
  };

  const scheduleChatScrollLockSync = () => {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(syncChatScrollLock);
  };

  /* The app gives each suggestion chip a "!w-[80%]" class; drop it so our stylesheet (pill chips) controls the size. */
  const normalizeSuggestionButtons = () => {
    document.querySelectorAll("#concierge-chatbot .suggestion-btn").forEach((button) => {
      button.classList.remove("!w-[80%]");
    });
  };

  const closeChat = () => {
    const overlay = getOpenOverlay();
    const closeButton = overlay?.querySelector(
      'button[title="Close chat"], button[aria-label="Close chat"]'
    );

    if (closeButton) {
      closeButton.click();
    }

    scheduleChatScrollLockSync();
  };

  const handleDocumentClick = (event) => {
    const target = event.target;
    const overlay = getOpenOverlay();
    const toggle = document.querySelector(toggleSelector);

    if (
      overlay &&
      target instanceof Node &&
      !overlay.contains(target) &&
      !toggle?.contains(target)
    ) {
      event.preventDefault();
      event.stopPropagation();
      closeChat();
      return;
    }

    if (target instanceof Element && target.closest("#concierge-chatbot")) {
      normalizeSuggestionButtons();
    }
    scheduleChatScrollLockSync();
  };

  /* WhatsApp inside the chat: a green icon button in the chat header and a short line above the message box.
     The number and first message come from Theme settings > Chat and WhatsApp (window.QAZMI_WA). */
  const WA_ICON =
    '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path fill="#25D366" d="M.057 24l1.687-6.163a11.87 11.87 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.51 5.26l-.999 3.648 3.978-1.607zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg>';

  const NEWCHAT_ICON =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
  const CHAT_STORAGE = /^(concierge-chat-id:|chat-messages:|helium_shown_products)/;

  const getBotImageUrl = () => {
    const link = document.querySelector('link[href*="qazmi-chat-search.css"]');
    return link ? link.href.replace(/qazmi-chat-search\.css.*$/, "qazmi-bot.png") : "";
  };

  const hasSavedChat = () => {
    try {
      for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i);
        if (key && key.indexOf("chat-messages:") === 0) {
          const parsed = JSON.parse(window.localStorage.getItem(key) || "{}");
          return Object.values(parsed).some((list) => Array.isArray(list) && list.length > 0);
        }
      }
    } catch (e) { /* storage blocked or unexpected format */ }
    return false;
  };

  const startNewChat = () => {
    try {
      Object.keys(window.localStorage).forEach((key) => { if (CHAT_STORAGE.test(key)) window.localStorage.removeItem(key); });
      window.sessionStorage.setItem("qazmiReopenChat", "1");
      window.sessionStorage.setItem("qazmiTeaserSeen", "1");
    } catch (e) { /* ignore */ }
    window.location.reload();
  };

  /* after "New chat" the page reloads: open the chat again so it feels instant */
  const reopenChatIfAsked = () => {
    let ask = false;
    try { ask = window.sessionStorage.getItem("qazmiReopenChat") === "1"; window.sessionStorage.removeItem("qazmiReopenChat"); } catch (e) { /* ignore */ }
    if (!ask) return;
    let tries = 0;
    const timer = window.setInterval(() => {
      const launcher = document.querySelector(toggleSelector);
      if (launcher && launcher.getBoundingClientRect().width) { window.clearInterval(timer); launcher.click(); }
      else if (++tries > 40) window.clearInterval(timer);
    }, 250);
  };

  /* On a product page the message names the product and carries its link (with the chosen variant, if any), so the team knows what the customer is looking at. */
  const getProductInfo = () => {
    if (!/\btemplate-product\b/.test(document.body.className || "")) return null;
    const og = document.querySelector('meta[property="og:title"]');
    const h1 = document.querySelector("h1");
    const title = ((og && og.getAttribute("content")) || (h1 && h1.textContent) || document.title || "").replace(/\s+/g, " ").trim();
    const variant = new URLSearchParams(window.location.search).get("variant");
    const url = window.location.origin + window.location.pathname + (variant ? "?variant=" + encodeURIComponent(variant) : "");
    return title ? { title, url } : null;
  };

  const getWhatsAppUrl = () => {
    const cfg = window.QAZMI_WA || {};
    const number = String(cfg.number || "").replace(/\D/g, "");
    if (!number) return "";
    let message = cfg.text || "";
    const product = getProductInfo();
    if (product && cfg.productText) {
      message = String(cfg.productText).replace(/\{title\}/g, product.title).replace(/\{url\}/g, product.url);
    }
    const text = message ? "&text=" + encodeURIComponent(message) : "";
    return "https://api.whatsapp.com/send/?phone=" + number + text + "&type=phone_number&app_absent=0";
  };

  const WELCOME_TITLE = "How can I help you today?";
  const WELCOME_TEXT = "Ask about styles, sizes, delivery or returns.";

  const addWhatsAppToChat = () => {
    const overlay = document.querySelector(overlaySelector);
    const url = getWhatsAppUrl();
    if (!overlay) return;

    /* header: WhatsApp button, then the cart (the app's), then our own close button (X) at the far right */
    /* small Qazmi bot badge next to the name in the header */
    const botSrc = getBotImageUrl().replace("qazmi-bot.png", "qazmi-bot-mini.png");
    const headerLogo = overlay.querySelector('.chat-header img[alt="Bot Logo"]');
    if (headerLogo && botSrc && headerLogo.getAttribute("src") !== botSrc) {
      headerLogo.removeAttribute("srcset");
      headerLogo.setAttribute("src", botSrc);
    }

    const headerButtons = overlay.querySelectorAll(".chat-header-action-btn:not(.qz-wa-btn):not(.qz-close-btn)");
    const cartButton = headerButtons.length ? headerButtons[headerButtons.length - 1] : null;
    const actions = cartButton ? cartButton.parentElement : null;
    if (actions && url && !actions.querySelector(".qz-wa-btn")) {
      const a = document.createElement("a");
      a.className = "chat-header-action-btn qz-wa-btn";
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.title = "Chat with us on WhatsApp";
      a.setAttribute("aria-label", "Chat with us on WhatsApp");
      a.innerHTML = WA_ICON;
      actions.insertBefore(a, cartButton);
    }
    /* keep the WhatsApp links pointing at the current product / page */
    if (url) overlay.querySelectorAll(".qz-wa-btn, .qz-wa-link").forEach((el) => { if (el.getAttribute("href") !== url) el.setAttribute("href", url); });

    /* bottom line: "New chat" (only when there is a conversation) and the WhatsApp link */
    const footer = overlay.querySelector(".chat-footer");
    if (footer && footer.parentElement && !overlay.querySelector(".qz-wa-bar")) {
      const bar = document.createElement("div");
      bar.className = "qz-wa-bar";
      bar.innerHTML =
        '<button type="button" class="qz-newchat-link" hidden>' + NEWCHAT_ICON + "<span>New chat</span></button>" +
        (url ? '<a class="qz-wa-link" href="' + url + '" target="_blank" rel="noopener noreferrer">' + WA_ICON + "<span>Chat on WhatsApp</span></a>" : "");
      bar.querySelector(".qz-newchat-link").addEventListener("click", startNewChat);
      /* below the message box, at the very bottom of the chat window */
      footer.parentElement.insertBefore(bar, footer.nextSibling);
    }

    const newLink = overlay.querySelector(".qz-newchat-link");
    if (newLink) newLink.hidden = !hasSavedChat();

    /* greeting text: short and formal (the app's own text comes from its dashboard) */
    const welcome = overlay.querySelector(".welcome-container");
    if (welcome) {
      const h1 = welcome.querySelector("h1");
      const p = welcome.querySelector("p");
      if (h1 && h1.textContent !== WELCOME_TITLE) h1.textContent = WELCOME_TITLE;
      if (p && p.textContent !== WELCOME_TEXT) p.textContent = WELCOME_TEXT;
      /* three short facts under the greeting (all taken from the site: header bar, product pages, return policy) */
      if (p && !welcome.querySelector(".qz-welcome-facts")) {
        const facts = document.createElement("ul");
        facts.className = "qz-welcome-facts";
        facts.innerHTML =
          '<li><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6.5h11v9H3zM14 9.5h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg><span>Free shipping on all orders</span></li>' +
          '<li><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12a8 8 0 0 1 13.7-5.6M20 12a8 8 0 0 1-13.7 5.6M18.5 3.5v4h-4M5.5 20.5v-4h4"/></svg><span>Easy 7-day returns and exchange</span></li>' +
          '<li><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.2"/></svg><span>Buy 2, get \u20B9150 off</span></li>';
        p.parentElement.appendChild(facts);
      }
    }
  };

  /* WhatsApp links: open the direct link in a new tab ourselves. The chat app would otherwise show its own
     "Are you sure you want to leave Qazmi?" page. This runs first (window, capture phase). */
  window.addEventListener(
    "click",
    (event) => {
      const link = event.target instanceof Element ? event.target.closest(".qz-wa-btn, .qz-wa-link") : null;
      if (!link) return;
      const url = getWhatsAppUrl() || link.getAttribute("href");
      if (!url) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.open(url, "_blank", "noopener,noreferrer");
    },
    true
  );

  let waScheduled = false;
  const scheduleAddWhatsApp = () => {
    if (waScheduled) return;
    waScheduled = true;
    window.requestAnimationFrame(() => {
      waScheduled = false;
      addWhatsAppToChat();
    });
  };
  new MutationObserver(scheduleAddWhatsApp).observe(document.body, { childList: true, subtree: true });
  scheduleAddWhatsApp();

  /* Teaser: a small speech bubble next to the chat button, once per visit, to invite people to ask the Stylist.
     It shows after a few seconds, hides on click / after 12 seconds / when the chat opens, and is skipped on the cart page. */
  const initChatTeaser = () => {
    let seen = false;
    try { seen = window.sessionStorage.getItem("qazmiTeaserSeen") === "1"; } catch (e) { /* storage blocked: show once per page load */ }
    const tpl = ((document.body.className || "").match(/template-([a-z0-9_]+)/) || [])[1] || "";
    if (seen || tpl === "cart" || tpl === "customers" || tpl === "password") return;

    const messages = {
      product: "Not sure about your size? <b>Ask our Stylist</b>",
      collection: "Need help finding the right fit? <b>Ask our Stylist</b>",
      index: "Hi! Looking for something special? <b>Ask our Stylist</b>",
    };
    const html = messages[tpl] || "Need help choosing? <b>Ask our Stylist</b>";

    let teaser = null;
    let timer = null;
    const hide = (remember) => {
      if (timer) { window.clearTimeout(timer); timer = null; }
      if (teaser) { teaser.classList.remove("is-in"); const t = teaser; teaser = null; window.setTimeout(() => t.remove(), 300); }
      document.documentElement.classList.remove("qz-chat-nudge");
      if (remember) { try { window.sessionStorage.setItem("qazmiTeaserSeen", "1"); } catch (e) { /* ignore */ } }
    };
    const place = () => {
      const launcher = document.querySelector(toggleSelector);
      if (!teaser || !launcher) return;
      const r = launcher.getBoundingClientRect();
      if (!r.width) { hide(false); return; }
      teaser.style.right = Math.round(window.innerWidth - r.left + 10) + "px";
      teaser.style.bottom = Math.round(window.innerHeight - r.bottom + (r.height - 44) / 2) + "px";
    };
    const show = () => {
      if (getOpenOverlay() || document.querySelector(".m6pn.toggle, html.m6pn-open")) return;
      const launcher = document.querySelector(toggleSelector);
      if (!launcher || !launcher.getBoundingClientRect().width) return;
      teaser = document.createElement("div");
      teaser.className = "qz-chat-teaser";
      teaser.setAttribute("role", "status");
      teaser.innerHTML = '<button type="button" class="qz-chat-teaser__close" aria-label="Dismiss">&times;</button><span class="qz-chat-teaser__text">' + html + "</span>";
      document.body.appendChild(teaser);
      place();
      window.requestAnimationFrame(() => teaser && teaser.classList.add("is-in"));
      document.documentElement.classList.add("qz-chat-nudge");
      teaser.querySelector(".qz-chat-teaser__close").addEventListener("click", (e) => { e.stopPropagation(); hide(true); });
      teaser.querySelector(".qz-chat-teaser__text").addEventListener("click", () => { hide(true); const l = document.querySelector(toggleSelector); if (l) l.click(); });
      timer = window.setTimeout(() => hide(true), 12000);
    };
    window.addEventListener("resize", place);
    document.addEventListener("click", (e) => { if (teaser && e.target instanceof Element && e.target.closest(toggleSelector)) hide(true); }, true);
    window.setTimeout(show, 6000);
  };
  initChatTeaser();
  reopenChatIfAsked();

  document.addEventListener("click", handleDocumentClick, true);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && chatWasOpen) {
      closeChat();
    }
  });
  normalizeSuggestionButtons();
  syncChatScrollLock();
})();
